module.exports = "pegasus/assets/email1-twitter.png";